import { Flex, SidebarTrigger } from '@kognitos/lattice';
import { NavLink } from 'react-router-dom';
import { ROUTES } from '@/routes/util';
import {
  selectCurrentOrganizationId,
  selectCurrentWorkspaceId,
  useUserPreferencesStore,
} from '@/shared/stores';
import Logo from '@/shared/components/Logo';

import { SIDEBAR_LOGO_HEIGHT } from './sidebar-constants';

interface ISidebarTriggerBarProps {
  isCollapsed: boolean;
  onTriggerClick?: () => void;
  isHoverOverlay?: boolean;
}

const SidebarTriggerBar = ({
  isCollapsed,
  onTriggerClick,
  isHoverOverlay,
}: ISidebarTriggerBarProps) => {
  const currentOrganizationId = useUserPreferencesStore(
    selectCurrentOrganizationId,
  );
  const currentWorkspaceId = useUserPreferencesStore(selectCurrentWorkspaceId);

  const logoHref =
    currentOrganizationId && currentWorkspaceId
      ? ROUTES.AUTOMATIONS.build({
          orgId: currentOrganizationId,
          workspaceId: currentWorkspaceId,
        })
      : undefined;

  return (
    <Flex
      align="center"
      justify="between"
      className="shrink-0 w-full h-8 p-0 overflow-hidden"
    >
      <div className="w-8" style={{ height: `${SIDEBAR_LOGO_HEIGHT}px` }}>
        {logoHref ? (
          <NavLink to={logoHref}>
            <Logo size={SIDEBAR_LOGO_HEIGHT} className="text-sidebar-muted" />
          </NavLink>
        ) : (
          <Logo size={SIDEBAR_LOGO_HEIGHT} className="text-sidebar-muted" />
        )}
      </div>
      {!isCollapsed && (
        <SidebarTrigger
          className="h-7 w-7 text-sidebar-muted"
          onClick={onTriggerClick}
          // Clicking on the sidebar when it's in overlay mode
          // We are already toggling the side bar
          // Toggling it again will keep the sidebar in overlay mode
          toggleOnClick={!isHoverOverlay}
        />
      )}
    </Flex>
  );
};

export default SidebarTriggerBar;
